import React from "react"
import { css, keyframes } from "styled-components"

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Spinner = ({ color = "#00d9eddd", size = 50, line = 5 }) => (
  <div
    css={css`
      width: ${size}px;
      height: ${size}px;
      border-radius: 50%;
      border: ${line}px solid transparent;
      border-top: ${line}px solid ${color};
      border-left: ${line}px solid ${color};
      animation: 2s ${spin} linear infinite;
    `}
  />
)

export default Spinner
